
const IssueRequest = {
  "gdsRefrenceID": "string"
  };
 

  export default IssueRequest;
  